var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEventEmptyGrayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h200v200H.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.068 36.878A4.878 4.878 0 0 1 56.946 32h72.474a4.878 4.878 0 1 1 0 9.756h-15.331a4.878 4.878 0 1 0 0 9.756h35.54a6.272 6.272 0 1 1 0 12.544H40.221a6.272 6.272 0 1 1 0-12.544h29.965a4.867 4.867 0 0 1-1.742-.32 4.88 4.88 0 0 0 0-9.116 4.867 4.867 0 0 1 1.742-.32h-13.24a4.878 4.878 0 0 1-4.878-4.878ZM158.688 57.784a6.272 6.272 0 0 1 6.272-6.272h12.543a6.272 6.272 0 1 1 0 12.544H164.96a6.272 6.272 0 0 1-6.272-6.272ZM40.221 73.812a6.272 6.272 0 1 0 0 12.543h85.715a6.272 6.272 0 0 0 0-12.543H40.221ZM7.469 101.338a5.226 5.226 0 0 1 5.226-5.226h42.509a5.226 5.226 0 1 1 0 10.452h-2.09a5.227 5.227 0 0 0 0 10.453h33.449a5.226 5.226 0 1 1 0-10.453h78.745a5.227 5.227 0 1 1 0 10.453h-14.285a5.227 5.227 0 1 0 0 10.453h8.014a5.227 5.227 0 0 1 0 10.453h-32.056a5.227 5.227 0 0 1 0 10.453H85.866a5.227 5.227 0 0 0 0 10.453h6.272a5.227 5.227 0 0 1 0 10.453H48.932a5.226 5.226 0 1 1 0-10.453h.697a5.226 5.226 0 1 0 0-10.453H5.726a5.226 5.226 0 1 1 0-10.453h20.906a5.226 5.226 0 1 1 0-10.453h1.046a5.226 5.226 0 1 0 0-10.453h-2.44a5.226 5.226 0 1 1 0-10.453H12.696a5.226 5.226 0 0 1-5.226-5.226ZM182.033 106.564a5.227 5.227 0 0 0 0 10.453h13.241a5.226 5.226 0 0 0 0-10.453h-13.241Z",
    fill: "#F6F8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.845 150.467a4.181 4.181 0 0 0 0 8.362h9.059a4.181 4.181 0 0 0 0-8.362h-9.059Z",
    fill: "#F6F8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.621 35.53a2.062 2.062 0 1 1 0 4.124H41.248a2.062 2.062 0 0 1 0-4.124H53.62ZM30.936 35.53a2.062 2.062 0 1 1 0 4.124H18.562a2.062 2.062 0 0 1 0-4.124h12.374ZM38.154 55.121a2.062 2.062 0 1 1-4.125 0V42.748a2.062 2.062 0 0 1 4.125 0V55.12ZM38.154 32.436a2.062 2.062 0 0 1-4.125 0V20.062a2.062 2.062 0 0 1 4.125 0v12.374ZM171.895 55.312a1.09 1.09 0 0 1 1.54 1.539l-4.618 4.618a1.088 1.088 0 1 1-1.539-1.54l4.617-4.617ZM163.429 63.778a1.09 1.09 0 0 1 1.54 1.539l-4.618 4.618a1.09 1.09 0 0 1-1.54-1.54l4.618-4.617ZM173.435 68.395a1.089 1.089 0 1 1-1.54 1.54l-4.617-4.618a1.088 1.088 0 1 1 1.539-1.54l4.618 4.618ZM164.969 59.93a1.089 1.089 0 1 1-1.54 1.539l-4.618-4.618a1.089 1.089 0 1 1 1.54-1.54l4.618 4.618ZM44.752 159.088a1.088 1.088 0 0 1 2.177 0v6.531a1.088 1.088 0 0 1-2.177 0v-6.531ZM44.752 171.061a1.088 1.088 0 0 1 2.177 0v6.531a1.088 1.088 0 0 1-2.177 0v-6.531ZM55.092 167.252a1.088 1.088 0 1 1 0 2.177h-6.53a1.089 1.089 0 0 1 0-2.177h6.53ZM43.12 167.252a1.088 1.088 0 1 1 0 2.177h-6.532a1.089 1.089 0 0 1 0-2.177h6.531Z",
    fill: "#D4DDEC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.854,
    cy: 69.354,
    fill: "#EEF2F5",
    r: 4.354
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.854,
    cy: 168.354,
    fill: "#EEF2F5",
    r: 4.354
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.384 181.048a8.164 8.164 0 1 0 0-16.328 8.164 8.164 0 0 0 0 16.328Zm0 2.721c6.012 0 10.885-4.873 10.885-10.885 0-6.011-4.873-10.884-10.885-10.884-6.011 0-10.884 4.873-10.884 10.884 0 6.012 4.873 10.885 10.884 10.885ZM89.384 35.048a8.163 8.163 0 1 0 0-16.327 8.163 8.163 0 0 0 0 16.327Zm0 2.72c6.012 0 10.885-4.872 10.885-10.884 0-6.01-4.873-10.884-10.885-10.884-6.01 0-10.884 4.873-10.884 10.884 0 6.012 4.873 10.885 10.884 10.885Z",
    fill: "#D4DDEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m148.458 88.775-21.474 21.968 5.071 31.027c.221 1.357-.31 2.728-1.372 3.539-.6.459-1.313.691-2.027.691-.548 0-1.1-.137-1.603-.416L100.5 130.935 73.95 145.58a3.298 3.298 0 0 1-3.63-.275c-1.062-.81-1.592-2.181-1.372-3.538l5.072-31.027L52.54 88.775a3.747 3.747 0 0 1-.872-3.708c.407-1.306 1.486-2.265 2.786-2.464l29.68-4.522 13.272-28.228c1.162-2.47 5.024-2.47 6.185 0l13.273 28.227 29.68 4.523c1.3.199 2.379 1.154 2.786 2.464a3.744 3.744 0 0 1-.873 3.708Z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.248 120.337-10.07 5.357-1.697 11.55c-.074.505-.417.93-.884 1.098a1.239 1.239 0 0 1-1.315-.311l-7.748-8.171-11.042 2.195a1.226 1.226 0 0 1-1.253-.506 1.376 1.376 0 0 1-.088-1.407l5.286-10.408-5.129-10.189a1.392 1.392 0 0 1 .109-1.41c.291-.416.78-.634 1.263-.558l11.011 1.739 7.872-8.495c.689-.744 2.056-.309 2.189.696l1.52 11.481 9.994 4.94c.437.217.711.676.708 1.185-.003.51-.285.978-.726 1.214Z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.187 108.324-5.734 11.454 5.959 11.676c.26.511.223 1.122-.095 1.579a1.382 1.382 0 0 1-1.406.571l-12.407-2.44-8.681 9.191a1.373 1.373 0 0 1-1.477.352 1.543 1.543 0 0 1-.994-1.23l-1.932-12.966-11.322-5.991a1.562 1.562 0 0 1-.818-1.362 1.463 1.463 0 0 1 .793-1.332l11.211-5.57 1.681-12.897c.147-1.129 1.68-1.62 2.456-.786l8.86 9.521 12.361-1.978a1.462 1.462 0 0 1 1.42.624c.328.468.374 1.081.125 1.584Z",
    fill: "url(#d)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 79.063,
    y1: 130.687,
    x2: 150.883,
    y2: 46.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9D2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF1FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 146.977,
    y1: 127.36,
    x2: 181.807,
    y2: 105.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9D2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF1FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 37.959,
    y1: 133.791,
    x2: 55.837,
    y2: 91.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9D2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF1FA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h200v200H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventEmptyGrayIcon);
export default __webpack_public_path__ + "static/media/event-empty-gray-icon.7256dbec5f42490f5cc87d2bb5329baf.svg";
export { ForwardRef as ReactComponent };